import React, { useState, useEffect } from 'react';
import { AxiosResponse } from 'axios';
import Cookies from 'js-cookie';

// APIs
import api from '../../services/api';
import apiPSMedway from '../../services/PSMedway/api';
import apiMentoria from '../../services/Mentoria/api';
import apiExtensivo from '../../services/Extensivo/api';
import apiCRMedway from '../../services/CRMedway/api';
import apiECG from '../../services/ECG/api';
import apiAnaliseDeDados from '../../services/Analise-de-dados/api';
import apiIntensivo from '../../services/Intensivo/api';

// RDStation
import apiRD from '../../services/RD/api';

// Styles
import { Contanner } from './styles';
import Loading from '../../components/Loading';

interface Aula {
  background: {
    title: string;
    sizes: {
      '1920x1080': string;
    };
  };
  logo_do_curso: {
    title: string;
    sizes: {
      '1920x1080': string;
    };
  };
  nome: string;
  texto: string;
  curso: string;
  url: string;
  nome_botao: string;
}

const ListaDePresencaV2: React.FC = () => {
  const [email, setEmail] = useState('');
  const [nome, setNome] = useState('');
  const [aula, setAula] = useState<Aula>();
  const [section, setSection] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
  };

  const handleChangeNome = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNome(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();

    apiRD.get(
      `/conversions.json?token_rdstation=c563b3f05f59736e762abdce76235dff&identificador=${aula?.curso}&_is=6&c_utmz=&traffic_source=&client_id=&redirect_to=&_doe=&privacy_data%5Bbrowser%5D=&name=${nome}&email=${email}&custom_fields%5B1435345%5D=${aula?.curso}&custom_fields%5B1435348%5D=${aula?.nome}&emP7yF13ld=&sh0uldN07ch4ng3=should_not_change`
    );

    apiAnaliseDeDados.post('/lista-de-presenca-minicurso', {
      email,
      aula: aula?.nome,
      nome,
      curso: aula?.curso,
    });

    setSection(true);
  };

  useEffect(() => {
    const ID = Cookies.get('pageID');
    const hostName = window.location.hostname;

    switch (hostName) {
      case 'mentoria.medway.com.br':
        apiMentoria
          .get(`acf/v3/pages/${ID}`)
          .then((response: AxiosResponse) => {
            setAula({
              background: response.data.acf.lista_de_presenca_v2.background,
              logo_do_curso: response.data.acf.lista_de_presenca_v2.logo,
              nome: response.data.acf.lista_de_presenca_v2.nome,
              texto: response.data.acf.lista_de_presenca_v2.texto,
              curso: response.data.acf.lista_de_presenca_v2.curso,
              url: response.data.acf.lista_de_presenca_v2.link,
              nome_botao: response.data.acf.lista_de_presenca_v2.botao,
            });
          });
        break;
      case 'extensivo.medway.com.br':
        apiExtensivo
          .get(`acf/v3/pages/${ID}`)
          .then((response: AxiosResponse) => {
            setAula({
              background: response.data.acf.lista_de_presenca_v2.background,
              logo_do_curso: response.data.acf.lista_de_presenca_v2.logo,
              nome: response.data.acf.lista_de_presenca_v2.nome,
              texto: response.data.acf.lista_de_presenca_v2.texto,
              curso: response.data.acf.lista_de_presenca_v2.curso,
              url: response.data.acf.lista_de_presenca_v2.link,
              nome_botao: response.data.acf.lista_de_presenca_v2.botao,
            });
          });
        break;
      case 'intensivo.medway.com.br':
        apiIntensivo
          .get(`acf/v3/pages/${ID}`)
          .then((response: AxiosResponse) => {
            setAula({
              background: response.data.acf.lista_de_presenca_v2.background,
              logo_do_curso: response.data.acf.lista_de_presenca_v2.logo,
              nome: response.data.acf.lista_de_presenca_v2.nome,
              texto: response.data.acf.lista_de_presenca_v2.texto,
              curso: response.data.acf.lista_de_presenca_v2.curso,
              url: response.data.acf.lista_de_presenca_v2.link,
              nome_botao: response.data.acf.lista_de_presenca_v2.botao,
            });
          });
        break;
      case 'cr.medway.com.br':
        apiCRMedway
          .get(`acf/v3/pages/${ID}`)
          .then((response: AxiosResponse) => {
            setAula({
              background: response.data.acf.lista_de_presenca_v2.background,
              logo_do_curso: response.data.acf.lista_de_presenca_v2.logo,
              nome: response.data.acf.lista_de_presenca_v2.nome,
              texto: response.data.acf.lista_de_presenca_v2.texto,
              curso: response.data.acf.lista_de_presenca_v2.curso,
              url: response.data.acf.lista_de_presenca_v2.link,
              nome_botao: response.data.acf.lista_de_presenca_v2.botao,
            });
          });
        break;
      case 'ps.medway.com.br':
        apiPSMedway
          .get(`acf/v3/pages/${ID}`)
          .then((response: AxiosResponse) => {
            setAula({
              background: response.data.acf.lista_de_presenca_v2.background,
              logo_do_curso: response.data.acf.lista_de_presenca_v2.logo,
              nome: response.data.acf.lista_de_presenca_v2.nome,
              texto: response.data.acf.lista_de_presenca_v2.texto,
              curso: response.data.acf.lista_de_presenca_v2.curso,
              url: response.data.acf.lista_de_presenca_v2.link,
              nome_botao: response.data.acf.lista_de_presenca_v2.botao,
            });
          });
        break;
      case 'ecg.medway.com.br':
        apiECG.get(`acf/v3/pages/${ID}`).then((response: AxiosResponse) => {
          setAula({
            background: response.data.acf.lista_de_presenca_v2.background,
            logo_do_curso: response.data.acf.lista_de_presenca_v2.logo,
            nome: response.data.acf.lista_de_presenca_v2.nome,
            texto: response.data.acf.lista_de_presenca_v2.texto,
            curso: response.data.acf.lista_de_presenca_v2.curso,
            url: response.data.acf.lista_de_presenca_v2.link,
            nome_botao: response.data.acf.lista_de_presenca_v2.botao,
          });
        });
        break;
      default:
        api.get(`acf/v3/pages/${ID}`).then((response: AxiosResponse) => {
          setAula({
            background: response.data.acf.lista_de_presenca_v2.background,
            logo_do_curso: response.data.acf.lista_de_presenca_v2.logo,
            nome: response.data.acf.lista_de_presenca_v2.nome,
            texto: response.data.acf.lista_de_presenca_v2.texto,
            curso: response.data.acf.lista_de_presenca_v2.curso,
            url: response.data.acf.lista_de_presenca_v2.link,
            nome_botao: response.data.acf.lista_de_presenca_v2.botao,
          });
        });
        break;
    }
  }, []);

  return (
    <>
      {aula ? (
        <Contanner bg={aula?.background.sizes['1920x1080']}>
          <img
            src={aula?.logo_do_curso.sizes['1920x1080']}
            alt={aula?.logo_do_curso.title}
          />
          <h1>{aula?.nome}</h1>
          <div
            className="box-text"
            dangerouslySetInnerHTML={{
              __html: aula?.texto,
            }}
          />
          {section ? (
            <>
              <a href={aula?.url} target="_blank" rel="noreferrer">
                {aula?.nome_botao}
              </a>
            </>
          ) : (
            <>
              <form onSubmit={handleSubmit}>
                <div>
                  <label htmlFor="InputName">Nome completo</label>
                  <input
                    id="InputName"
                    type="text"
                    name="name"
                    value={nome}
                    onChange={handleChangeNome}
                    placeholder="João Silva"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="InputEmail">E-mail</label>
                  <input
                    id="InputEmail"
                    type="email"
                    name="email"
                    value={email}
                    onChange={handleChange}
                    placeholder="alguem@exemplo.com"
                    required
                  />
                </div>
                <button type="submit">Enviar</button>
              </form>
            </>
          )}
        </Contanner>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default ListaDePresencaV2;
